export const FAQS = [
  {
    q: 'What does verification actually check?',
    a: 'Every generated shot is checked against two things: the story context — character identity, wardrobe, location, and causal order — and our Cinematic Constitution covering framing, eyelines, screen direction, and continuity of light. Only shots that pass both reach the director\'s timeline.',
  },
  {
    q: 'How is causal reasoning different from continuity memory?',
    a: 'Memory remembers what a character looks like. Causal reasoning understands what has to happen: the door opens before she walks through it, the glass shatters before the shards fall. Rhapsody plans each shot against what preceded it and what must follow, so the story holds — not just the faces.',
  },
  {
    q: 'Which models do you use?',
    a: 'All of the best ones — Kling, Seedance, Veo, Gemini Omini Flash, Flux — and whichever ships next. We treat generation models as swappable engines and route each shot to the best fit. The correctness layer is ours; the pixels come from whoever\'s currently winning the quality race.',
  },
  {
    q: 'How are generation and retries priced?',
    a: 'Generation and retries are subject to your plan’s usage terms. Enterprise agreements define included usage, retry allowances, and overage rates. Verification checks quality; it does not guarantee free retries.',
  },
  {
    q: 'Who owns the content I generate?',
    a: 'You do. Full commercial-use rights on every tier. What you generate is yours.',
  },
] as const;
